<template>
    <div class="container">
        <div class="info">
            <div class="info-name">型号</div>
            <div class="info-text">彼馨L18</div>
        </div>
        <div class="info">
            <div class="info-name">IMEI</div>
            <div class="info-text">{{imei}}</div>
        </div>
        <div class="un-bind" @click="modal=true">解绑设备</div>
        <div class="unbind-modal" v-show="modal">
            <div class="unbind">
                <div class="unbind-title">解绑设备</div>
                <div class="unbind-content">解绑后将无法呈现您的情绪报告</div>
                <div class="btns">
                    <div class="cancel" @click="modal=false">取消</div>
                    <div class="sure" @click="unBind">确定</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {unbind_imei} from '../api/my'
export default {
    props: {},
    components: {},
    data() {
        return {
            imei:'',
            loginPhone:'',
            modal:false,
        };
    },
    computed: {},
    watch: {},
    created() {
        let imei=localStorage.getItem('imei')
        this.imei=imei 
        let phone=localStorage.getItem('phone')
        this.loginPhone=phone 
    },
    mounted() {},
    methods: {
        unBind(){
            unbind_imei(this.loginPhone,this.imei).then(res=>{
                if(res.status==200){
                    this.$toast('解绑成功');
                    localStorage.removeItem('imei')
                    this.$router.push('/my')
                }
            })
        }
    },
};
</script>

<style scoped lang="less">
.container{
    padding: 16px;
}
.info{
    height: 70px;
    display: flex;
    justify-content: space-between;
    padding: 0px 12px;
    margin-bottom: 10px;
    background-color: #fff;
    border-radius: 10px;
}
.info-name{
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
}
.info-text{
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    color: #999;
}
.un-bind{
    height: 50px;
    margin-top: 30px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #FF0036;
    border-radius: 25px;
    border: 1px solid #FF0036;
}
.unbind-modal{
    position: fixed;
    left: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 10;
    width: 100%;
    height: 100%;
}
.unbind{
    width: 210px;
    padding: 30px;
    background-color: #fff;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.unbind-title{
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin-bottom: 30px;
    text-align: center;
}
.unbind-content{
    line-height: 20px;
    font-size: 14px;
    color: #333;
    margin-bottom: 30px;
    text-align: center;
}
.btns{
    height: 48px;
    display: flex;
    justify-content: space-between;
}
.cancel{
    height: 48px;
    width: 48%;
    border-radius: 24px;
    line-height: 48px;
    text-align: center;
    background-color: #F2F6F6;
    font-size: 16px;
    font-weight: 500;
    color: #333;
}
.sure{
    height: 48px;
    width: 48%;
    border-radius: 24px;
    line-height: 48px;
    text-align: center;
    background-color: #01D6D6;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
}
</style>
